import Carousel from 'nuka-carousel';

import { BREAKPOINTS, useBreakpoint } from '../../utils/useBreakpoint';
import { USPItem } from '../USPItem';
import { StyledBox } from '@widget/components/UspList/LocalizedUspList';

import type { USPItemProps } from '../USPItem';

type GenericUspListProps = {
  upsItems: USPItemProps[] | undefined | null;
};

export const GenericUspList = ({ upsItems }: GenericUspListProps): JSX.Element => {
  const breakpoint = useBreakpoint() || '';
  const isPhoneScreen = [BREAKPOINTS.xs, BREAKPOINTS.sm].includes(breakpoint);

  return (
    <>
      {isPhoneScreen && (
        <StyledBox>
          <Carousel
            autoplay
            wrapAround
            defaultControlsConfig={{
              nextButtonStyle: {
                display: 'none',
              },
              prevButtonStyle: {
                display: 'none',
              },
              pagingDotsStyle: {
                display: 'none',
              },
            }}
          >
            {upsItems?.map((props, index) => (
              <USPItem key={index} {...props} />
            ))}
          </Carousel>
        </StyledBox>
      )}
      {!isPhoneScreen && (
        <>
          {upsItems?.map((props, index) => (
            <USPItem key={index} {...props} />
          ))}
        </>
      )}
    </>
  );
};
